import { useState } from 'react';
import axios from 'axios';

import type { AxiosResponse } from 'axios';
import type { AxiosConfigResolver, UseAxiosCallbackReturn } from '../../types';

const useAxiosCallback = <TData = unknown, TReqData = unknown>(
    configResolver: AxiosConfigResolver<TReqData>
): UseAxiosCallbackReturn<TData, TReqData> => {
    const [data, setData] = useState<TData | undefined>(undefined);
    const [response, setResponse] = useState<AxiosResponse<TData> | undefined>(undefined);
    const [error, setError] = useState<unknown>('');
    const [loading, setLoading] = useState(false);
    const [execCount, setExecCount] = useState(0);

    const fetchData = async (reqData: TReqData | undefined, configResolver: AxiosConfigResolver<TReqData>) => {
        try {
            setLoading(true);
            setError('');
            setResponse(undefined);
            setData(undefined);
            const params = await configResolver(reqData);
            const result = await axios.request<TData>(params);
            setResponse(result);
            setData(result.data);
        } catch (err) {
            setError(err);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const exec = (reqData?: TReqData) => {
        setExecCount(execCount + 1);
        fetchData(reqData, configResolver);
    };

    return [exec, loading, { error, response, data, execCount }];
};

export default useAxiosCallback;
